import { INotification } from '@interfaces/notification';

export class GetNotifications {
  static readonly type = '[NOTIFICATIONS] Get notifications';
  constructor() {}
}

export class GetNotificationsSuccess {
  static readonly type = '[NOTIFICATIONS] Get notifications success';
  constructor(public payload: INotification[]) {}
}

export class GetNotificationsFail {
  static readonly type = '[NOTIFICATIONS] Get notifications failed';
  constructor(public payload: any) {}
}

export class SaveNotification {
  static readonly type = '[NOTIFICATIONS] Save notification';
  constructor(
    public payload: INotification,
    public inDialog: boolean = false
  ) {}
}

export class SaveNotificationSuccess {
  static readonly type = '[NOTIFICATIONS] Save notification success';
  constructor(
    public page: number,
    public top?: number,
    public inDialog: boolean = false
  ) {}
}

export class SaveNotificationFail {
  static readonly type = '[NOTIFICATIONS] Save notification failed';
  constructor(public payload: any) {}
}
